module.exports = __webpack_public_path__ + "img/defaultPortrait.c7a517ef.png";